import { FaceScreen } from '@/components/Biometric/FaceScreen';
import { PostMessageRequest } from '@/model/PostMessageRequest';
import { PostMessageResponse } from '@/model/PostMessageResponse';
import React, { JSX } from 'react';

interface StateProps {
  request?: PostMessageRequest;
}
interface DispatchProps {
  onAnalysisComplete: (data: PostMessageResponse) => void;
}

type Props = StateProps & DispatchProps;

export const BiometricFaceValid: React.FC<Props> = ({
  request,
  onAnalysisComplete,
}): JSX.Element => (
  <div className="flex flex-col justify-center text-center font-dmsans">
    {request && <FaceScreen request={request} onAnalysisComplete={onAnalysisComplete} />}
  </div>
);
